type SynergPreloader = {
  preloadComponentAndTheme?: (componentTags: string[]) => void;
};

// Every Waypoint tag rendered by the wrappers in `@pequity/shared/ui`
export const WAYPOINT_PRELOADED_COMPONENTS = [
  'sdf-alert',
  'sdf-alert-banner',
  'sdf-alert-inline',
  'sdf-alert-toast',
  'sdf-avatar',
  'sdf-badge',
  'sdf-box',
  'sdf-busy-indicator',
  'sdf-button',
  'sdf-calendar',
  'sdf-card',
  'sdf-checkbox',
  'sdf-data-ring',
  'sdf-date-picker-v2',
  'sdf-file-uploader',
  'sdf-floating-pane',
  'sdf-focus-pane',
  'sdf-icon',
  'sdf-icon-button',
  'sdf-input',
  'sdf-link',
  'sdf-menu',
  'sdf-menu-divider',
  'sdf-menu-item',
  'sdf-menu-title',
  'sdf-pagination',
  'sdf-progress-bar',
  'sdf-promo-box',
  'sdf-quick-stat',
  'sdf-radio-button',
  'sdf-radio-group',
  'sdf-search',
  'sdf-segmented-control',
  'sdf-select-simple',
  'sdf-skeleton',
  'sdf-spot-illustration',
  'sdf-switch',
  'sdf-tab',
  'sdf-tab-group',
  'sdf-tag',
  'sdf-textarea',
  'sdf-timeline',
  'sdf-timeline-event',
  'sdf-tooltip',
];

const runWhenIdle = (callback: () => void) => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback);
  } else {
    setTimeout(callback);
  }
};

/**
 * Preloads the JS bundles and themes of the wrapped Waypoint components once the browser is idle.
 * Waypoint lazy-loads both from the Synerg CDN on first mount, which makes components pop in late.
 */
export const preloadWaypointComponents = (synergConfig: SynergPreloader) => {
  runWhenIdle(() => synergConfig.preloadComponentAndTheme?.(WAYPOINT_PRELOADED_COMPONENTS));
};
